module.exports = __webpack_public_path__ + "static/img/zd_big.8d3b725a.png";